import { Controller } from "@hotwired/stimulus"

// Prevents Bootstrap collapse events from bubbling up to parent collapse elements
// This stops nested collapses from affecting parent collapse chevrons
export default class extends Controller {
  connect() {
    // Stop collapse events from bubbling up
    this.element.addEventListener('show.bs.collapse', this.stopPropagation)
    this.element.addEventListener('hide.bs.collapse', this.stopPropagation)
    this.element.addEventListener('shown.bs.collapse', this.stopPropagation)
    this.element.addEventListener('hidden.bs.collapse', this.stopPropagation)
  }

  disconnect() {
    this.element.removeEventListener('show.bs.collapse', this.stopPropagation)
    this.element.removeEventListener('hide.bs.collapse', this.stopPropagation)
    this.element.removeEventListener('shown.bs.collapse', this.stopPropagation)
    this.element.removeEventListener('hidden.bs.collapse', this.stopPropagation)
  }

  stopPropagation(event) {
    event.stopPropagation()
  }
}
